import { Publish } from 'src/Shared/EventPublisher/EventEmitter';
import { ConsentEventType } from 'src/Shared/EventPublisher/ConsentEventType';

class ConsentManagementService {
  constructor() {
    Publish(ConsentEventType.REQUEST_SHOW_EXPLICIT_LAYER);
  }

  public ShowPreferences(): void {
    Publish(ConsentEventType.REQUEST_SHOW_PREFERENCES_LAYER);
  }
}

export { ConsentManagementService };
